import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import RemoveStackItem from './remove-stack-item';
import {isPlayerStackType} from 'components/organisms/player-position-stacking/helpers';

const stackTypesMap = {
    [Const.STACKS_TYPE_AT_LEAST]: 'no less than',
    [Const.STACKS_TYPE_EXACTLY]: 'exactly',
    [Const.STACKS_TYPE_AT_MOST]: 'no more than',
};

class Stacks extends Component {
    isStackBoostUsed() {
        const {sportConfig} = this.props;

        return sportConfig.isGameTypeClassic();
    }
    isKeyPlayerLineupPositionUsed() {
        const {sportConfig} = this.props;

        return sportConfig.isGameTypeShowDownOrSingleGame();
    }
    getPlayerNames(playerIds) {
        const {players} = this.props;

        const names = [];
        playerIds.map((playerId) => {
            const player = players.getPlayer(playerId);
            player && names.push(player.name);
        });

        return names;
    }
    getStackLabel(stackItem) {
        const {players} = this.props;

        const {exclusionSettings} = stackItem;
        const player = players.getPlayer(stackItem.keyPlayers[0] ?? '');

        const labelItems = [];

        this.isStackBoostUsed() && labelItems.push(`(Stack Boost ${stackItem.stackBoostPercent}%), `);

        labelItems.push(`If ${stackItem.keyPositions[0] ?? ''} `);

        player && labelItems.push(`${player.name} `);

        labelItems.push('is ');

        this.isKeyPlayerLineupPositionUsed()
            ? labelItems.push(`${stackItem.keyPlayerLineupPosition} `)
            : labelItems.push('in lineup ');

        labelItems.push('then stack with ');

        stackItem.type in stackTypesMap && labelItems.push(`${stackTypesMap[stackItem.type]} `);

        labelItems.push(`${stackItem.numberPlayers} `);

        if (stackItem.stackWith === Const.STACK_WITH_POSITION) {
            labelItems.push(`${stackItem.selectedPositions.join('/')}'s from the `);
            labelItems.push(stackItem.isSameTeam ? 'Same team ' : 'Opposing team ');
        } else if (stackItem.stackWith === Const.STACK_WITH_PLAYER) {
            labelItems.push(this.getPlayerNames(stackItem.selectedPlayers).join(', '));
        }

        if (isPlayerStackType(stackItem.stackWith) || !exclusionSettings.isExclusionEnabled) {
            return labelItems.join('');
        }

        labelItems.push('exclude ');

        if (exclusionSettings.exclusionType === Const.STACK_WITH_PLAYER_EXCLUSION) {
            labelItems.push(this.getPlayerNames(exclusionSettings.excludedPlayers).join(', '));
        } else {
            labelItems.push(exclusionSettings.excludedTeams.join(', '));
        }

        return labelItems.join('');
    }

    render() {
        const {stacking} = this.props;

        return (
            <div className="advanced-tags">
                {Object.values(stacking.getItems()).map((stackItem) => {
                    return (
                        <span key={stackItem.getId()} className="advanced-tag">
                            {this.getStackLabel(stackItem)}
                            <RemoveStackItem itemId={stackItem.getId()} />
                        </span>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerPositionStacking, playersData, sportConfig} = state;

    return {
        stacking: playerPositionStacking,
        players: playersData.players,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(Stacks);
